export default __webpack_public_path__ + "static/media/ic_no_conversation.8828bc47.svg";